import type { User } from 'firebase/auth'
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { db } from './config'

export interface RecipeSubmission {
  url: string
  domain: string
  path: string
  submittedBy: string
  submittedAt: ReturnType<typeof serverTimestamp>
  status: 'pending'
  displayName: string | null
  email: string | null
}

export async function submitRecipeUrl(user: User, url: string): Promise<string> {
  const parsed = new URL(url)
  const doc = await addDoc(collection(db, 'recipe_submissions'), {
    url,
    domain: parsed.hostname,
    path: parsed.pathname,
    submittedBy: user.uid,
    submittedAt: serverTimestamp(),
    status: 'pending',
    displayName: user.displayName,
    email: user.email
  } satisfies RecipeSubmission)
  return doc.id
}
